import React from "react";

const AuthPageLayout = ({
  children,
  noBanner = false,
}: {
  children: React.ReactNode;
  noBanner?: boolean;
}) => {
  return (
    <div
      className={`flex flex-col lg:flex-row-reverse h-screen ${
        noBanner ? "justify-center" : ""
      }`}
    >
      {!noBanner && (
        <div className="w-full h-64 lg:h-full lg:w-1/2 bg-secondary flex flex-col items-center lg:items-start justify-center">
          <div
            style={{
              backgroundImage: "url(/images/auth/auth-img.png)",
              backgroundSize: "cover",
              backgroundPosition: "left",
              backgroundRepeat: "no-repeat",
            }}
            className="w-full h-full"
          ></div>
        </div>
      )}

      <div className="w-full lg:w-1/2 bg-white p-3xl flex flex-col justify-center">
        <div className="max-w-container-md mx-auto w-full">{children}</div>
      </div>
    </div>
  );
};

export default AuthPageLayout;
